"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import HeroSection from "./components/heroSection";
import TalkToUs from "app/components/shared/talkToUs";
import CustomCarousel from "app/components/shared/CustomCarousel";
import Services from "./components/professionalService";
import Offerings from "./components/offerings";
import Certificates from "app/components/views/home/Certificates";
import TechStack from "./components/techStack";
import NetworkUseCases from "./components/networkUseCases";
import WhyAnsible from "./components/whyAnsible";

const AutomationPage = () => {
  return (
    <Box>
      <HeroSection />
      <WhyAnsible />
      <NetworkUseCases />
      <TechStack />
      <Offerings />
      <Services />
      <Certificates />
      <CustomCarousel />
      <TalkToUs />
    </Box>
  );
};

export default AutomationPage;
